import { CombinedDemandStats } from '../domain/stats';

export class DERDemandReader {

  public static storage(combinedDemand: CombinedDemandStats): Array<[number, number]> {
    return DERDemandReader.create(combinedDemand, true, false, false );
  }

  public static solar(combinedDemand: CombinedDemandStats): Array<[number, number]> {
    return DERDemandReader.create(combinedDemand, false, true, false );
  }

  public static fuelCell(combinedDemand: CombinedDemandStats): Array<[number, number]> {
    return DERDemandReader.create(combinedDemand, false, false, true );
  }

  public static loadBeforeBattery(combinedDemand: CombinedDemandStats): Array<[number, number]> {
    return DERDemandReader.create(combinedDemand, false, true, true, true) ||
      DERDemandReader.create(combinedDemand, false, true, false, true) ||
      DERDemandReader.create(combinedDemand, false, false, true, true);
  }


  // tslint:disable-next-line:max-line-length
  private static create(combinedDemand: CombinedDemandStats, storage: boolean, solar: boolean, fuelCell: boolean, noSubtract?: boolean): Array<[number, number]> {
    for (const adjStats of combinedDemand.partiallyAdjusted) {
      if (adjStats.storage === storage && adjStats.solar === solar && adjStats.fuelCell === fuelCell) {
        if (noSubtract) {
          return adjStats.stats;
        } else {
          return DERDemandReader.subtract( adjStats.stats, combinedDemand.demand );
        }
      }
    }
    return null;
  }

  private static subtract(series1: Array<[number, number]>, series2: Array<[number, number]>): Array<[number, number]> {
    const newStats: Array<[number, number]> = [];

    if (series1) {
      for (let i = 0;  i < series1.length;  i++) {
        if (series1[i][1] !== null && series2[i]) {
          newStats.push([ series1[i][0], (series1[i][1] - series2[i][1]) ]);
        }
      }
      return newStats;
    }

    return null;
  }

}
